import {
  updateUser,
  UpdateCustomer,
  unverifyUserPhone,
  userExistsWithPhoneNumber,
} from "../../api/services/userService.js";
import { mapMutations } from "vuex";
import { onlineOrdering } from "@/constants/strings";
export default {
  methods: {
    ...mapMutations([
      "setStoreLoaded",
      "setShowOverlay",
      "setVerificationPhone",
    ]),
    submitForm() {
      var that = this;
      let cms = [];
      let detail = this.$refs.myDetail.validate();

      cms.push(detail);
      Promise.all(cms).then((values) => {
        if (values.every((v) => v)) {
          that.saveProfile();
        } else {
          that.$el.querySelector("[aria-invalid=true]").focus();
        }
      });
    },
    async saveProfile() {
      this.loading = true;
      this.hasError = "";
      if (this.oldPhone != this.detailModel.Phone) {
        let exists = await userExistsWithPhoneNumber(this.detailModel.Phone);
        if (exists) {
          this.hasError = this.$t("message.mobileAlreadyRegisteredDescription");
          this.loading = false;
          return;
        }
      }

      const userUdid = this.user.id;
      try {
        await updateUser(userUdid, {
          FirebaseUDID: this.user.id,
          DeliveryAddress: {
            Phone: this.detailModel.Phone || "",
          },

          // pass source only for non branded stores
          Source: !this.isBranded()
            ? this.dbuser.Source
              ? this.dbuser.Source
              : onlineOrdering
            : null,
        });
        const updateResponse = await UpdateCustomer(userUdid, {
          FirstName: this.detailModel.FirstName,
          LastName: this.detailModel.LastName,
          PhoneNumber: this.detailModel.Phone,
          Email: this.detailModel.Email || this.user.email,
          HQCompanyID: this.currentStoreDoc.HQCompanyID,
        });
        if (updateResponse.data.Success) {
          if (this.oldPhone != this.detailModel.Phone) {
            // reset verification status
            await unverifyUserPhone({
              id: userUdid,
              email: this.user.email,
            });
            this.setVerificationPhone(this.detailModel.Phone);
            this.setShowOverlay(true);
            this.oldPhone = this.detailModel.Phone;
          }
          this.success = true;
          setTimeout(() => {
            this.success = false;
          }, 2000);
          this.hasError = false;
          this.loading = false;
        } else {
          this.loading = false;
          this.hasError = updateResponse.data.Status.Message;
        }
      } catch (error) {
        this.loading = false;
        this.hasError = error;
      }
    },
    initModel() {
      this.detailModel.FirstName = this.dbuser.FirstName;
      this.detailModel.LastName = this.dbuser.LastName;
      this.detailModel.Email = this.user.email || this.dbuser.Email;
      this.detailModel.Phone = this.dbuser.Mobile;
    },
  },
};
